import React, { useEffect } from 'react';
import './style.sass'
import BeneficiosPage from './beneficiosNew';
import GuestLayout from 'newComponents/Layout/MainLayout/GuestLayout';
import useTokenNew from 'newHooks/useTokenNew';
import { useValidateAccount } from 'newHooks/useValidateAccount';

export default function Beneficios() {

    const { access_token, isValid } = useTokenNew({name: 'Beneficios'})
    const { flow } = useValidateAccount()

    //- Codigo de instana para track de pagina 
    useEffect(()=>{
        // window.ineum('page', 'Benefits Credit-Page')
        // window.ineum('meta', 'portal', 'Credito')
    },[])

    return (
        <GuestLayout>
            <BeneficiosPage flow={flow} />
        </GuestLayout>
    )
}